import { useRef, useState } from 'react';

import { useOutsideDetect } from '@mint-lib/hooks';

import { useDataFileContext } from '../../../contexts/DataFileContext/useDataFileContext.js';
import {
  useDataFileClientStep,
  useIsDataFileContextFilled,
} from '../../../queries/index.js';
import { StaticContextData } from '../../molecules/StaticContextData.jsx';
import { UploadProgressCard } from '../../molecules/UploadProgressCard.jsx';
import { ContextFields } from '../ContextFields.jsx';

export const ContextPanel = () => {
  const { dataFileId, dataFilePreview } = useDataFileContext();
  const clientStep = useDataFileClientStep(dataFileId);
  const isUploadStep = clientStep === 'upload';
  const isContextFilled = useIsDataFileContextFilled(dataFileId);
  const isContextEditable =
    clientStep === 'header_selection' || clientStep === 'headers_mapping';

  const [hasUserOpened, setHasUserOpened] = useState(false);

  const isEditingMode =
    isUploadStep || (isContextEditable && (!isContextFilled || hasUserOpened));

  const contextFieldsContainer = useRef<null | HTMLDivElement>(null);
  const shouldCloseOnClickOutside = isEditingMode && isContextFilled;
  useOutsideDetect(contextFieldsContainer, shouldCloseOnClickOutside, () => {
    setHasUserOpened(false);
  });

  return (
    <div className="flex justify-between">
      {isEditingMode ? (
        <ContextFields
          ref={contextFieldsContainer}
          isUploadStep={isUploadStep}
        />
      ) : (
        <StaticContextData
          isEditable={isContextEditable}
          switchToEditingMode={() => setHasUserOpened(true)}
        />
      )}
      {dataFilePreview.status === 'uploading' && (
        <UploadProgressCard dataFileId={dataFileId} />
      )}
    </div>
  );
};
